import React from 'react'
import styled from 'styled-components'
import { useCookies, CookiesConsentEnum } from '@sentecacommerce-theme/lib'
import { CookieConsentProps } from './cookieConsent.props'
import { Modal } from '../Common'
import { BasicConsent, AdvancedConsent, Details } from './Components'

const CookieConsent = ({
  isEnabled,
  basic,
  advanced,
  details,
}: // TODO: add position (positionY & text alignment)
CookieConsentProps) => {
  const {
    cookiesMap,
    consentTab,
    returnToBasic,
    openAdvanced,
    handleDetails,
    cookie,
    handleToggle,
    cookiesConsent,
    onSave,
    onAcceptAll,
    isChecked,
  } = useCookies()

  const contentMap = {
    [CookiesConsentEnum.basic]: (
      <BasicConsent {...basic} setAdvanced={openAdvanced} onSave={onSave} />
    ),
    [CookiesConsentEnum.advancedProperties]: (
      <AdvancedConsent
        {...advanced}
        cookiesMap={cookiesMap}
        setDetails={handleDetails}
        handleToggle={handleToggle}
        onSave={onSave}
        onAcceptAll={onAcceptAll}
        isChecked={isChecked}
      />
    ),
    [CookiesConsentEnum.details]: (
      <Details
        cookie={cookie}
        cookiesMap={cookiesMap}
        details={details.table}
        goBack={details.goBack}
        handleBack={openAdvanced}
      />
    ),
  }

  const labelsMap = {
    [CookiesConsentEnum.basic]: 'Бисквитки',
    [CookiesConsentEnum.advancedProperties]: 'Разширени настройки',
  }

  // TODO: make FixedElement component (portal) to handle the fixed position
  return (
    <Modal
      isCookies
      maxWidth={consentTab !== CookiesConsentEnum.basic && '120rem'}
      isCookiesDetails={consentTab !== CookiesConsentEnum.basic}
      open={isEnabled && !cookiesConsent}
      title={
        consentTab === CookiesConsentEnum.details
          ? cookie
          : labelsMap[consentTab]
      }
      handleClose={returnToBasic}
    >
      <Container>{contentMap[consentTab]}</Container>
    </Modal>
  )
}

const Container = styled.div.attrs({
  className: 'd-flex flex-column container-fluid ',
})`
  line-height: 1.8rem;
  transition: all 0.3s ease-in-out;
  @media (min-width: ${({ theme }) => theme.breakpoints.lg.min}) {
    position: relative;
  }
`

export { CookieConsent }
